module.exports = __webpack_public_path__ + "img/wcfa-face-border.ff49bf23.png";